import { createApp } from 'vue'
import store from './store/store'
import App from '@/App.vue'
import i18n from '@/locales/index'
import router from '@/router/index'


const app = createApp(App)
app.use(store)
app.use(router)
app.use(i18n)
app.mount('#app')
